import Swiper, { SwiperSlide } from '@/components/common/Swiper';

const CategoriesSkeleton: React.FC<any> = ({ viewRef, cmsComponentKey }) => {
  return (
    <div
      className="bg-surface-100-bg min-h-[77px] flex pl-4 pr-0 pt-[21px] pb-4"
      ref={viewRef}
      data-module={cmsComponentKey}>
      <Swiper slidesPerView="auto">
        {new Array(6).fill(0).map((_item, index) => {
          return (
            <SwiperSlide className="!w-[68px]" key={`category-item-skeleton-${index}`}>
              <div className="w-14 h-14 mx-auto my-0 rounded-[50%] bg-surface-200-bg" />
              <div className="bg-surface-200-bg mx-auto mt-1 h-4 w-[56px] rounded-500" />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default CategoriesSkeleton;
